/**
 * Notification-related models
 * These will be expanded as notification features are implemented
 */

/**
 * Notification DTO (Response)
 */
export interface NotificationDto {
  id: string;
  recipientId?: string | null;
  leaseId?: string | null;
  type: string;
  subject: string;
  message: string;
  status: string;
  sentAt?: string | null;
  readAt?: string | null;
  createdAt: string;
}

/**
 * Send notification request
 */
export interface SendNotificationRequest {
  recipientId?: string | null;
  leaseId?: string | null;
  type: string;
  subject: string;
  message: string;
}

